const Lisatiedot = (title, styleClasses) => {
  return {
    anchor: "lisatiedot",
    components: [
      {
        anchor: "A",
        name: "StatusTextRow",
        styleClasses: styleClasses || ["pt-2 whitespace-pre-wrap"],
        properties: {
          title
        }
      }
    ]
  };
};

export default Lisatiedot;
